import React from 'react'

export default function({ userId, handleFileSelect, selectedFile }) {
  return (
    <div className="custom-file">
      <input disabled={userId ? false : true} type="file" className="custom-file-input" onChange={e => {handleFileSelect(e)}} />
      <label className="custom-file-label">
        {selectedFile ? selectedFile.name : 'Upload File'}
      </label>
    </div>
  )

};

